import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

import ZoneSoilItemFull from 'edit/ZoneSoilItemFull';
import ZoneSoilItemShort from 'edit/ZoneSoilItemShort';
import List from 'common/List';
import { Button } from '@tcc/crate';

const baseString = 'vra-zone-soil-composition';
const classString = classNames({
  [`${baseString}`]: true
});
let ZoneSoilCompositionContainer = ({
  onClick,
  soils,
  soilsAreVisible,
  tabIndex,
  zoneId
}) => {
  if (!soils.length) {
    return null;
  }

  const ZoneSoilItem = soilsAreVisible
    ? ZoneSoilItemFull
    : ZoneSoilItemShort;

  soils = soils.map((soil, index) => (<ZoneSoilItem key={`${zoneId}-soil-${index}`} soil={soil} />));

  return (
    <section className={classString}>
      <List name={`${zoneId}-soils`}>{soils}</List>
      <Button
        mode='link'
        onClick={onClick}
        tabIndex={tabIndex}
        testId='moreLink'>
        {getMessage(`button-text__${ soilsAreVisible ? 'less' : 'more' }`)}
      </Button>
    </section>
  );
};

ZoneSoilCompositionContainer.propTypes = {
  onClick: PropTypes.func,
  soils: PropTypes.array,
  soilsAreVisible: PropTypes.bool,
  tabIndex: PropTypes.number,
  zoneId: PropTypes.string
};
export default ZoneSoilCompositionContainer;
